import { apiAuth, apiResponseType } from ".";

export const getSelectPaymentForms = () =>
  apiAuth.get(`payment-forms/select`) as apiResponseType;
